module.exports = __webpack_public_path__ + "img/img0109.018f7330.png";